import { render, staticRenderFns } from "./konturAdmin.vue?vue&type=template&id=8f81dd02&"
import script from "./konturAdmin.vue?vue&type=script&lang=js&"
export * from "./konturAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports